export const getEnvironment = (hostname: string) => {
  return hostname.endsWith(".com") ? "production" : "development";
};
